<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-26 22:13:19
 * @LastEditors: Francis
 * @LastEditTime: 2022-08-02 14:01:51
-->
<template>
  <ul class="footer flex jc-sa w100pc fixed bg-fff aic">
    <li class="item" v-for="(menu, index) in menuList" :key="menu.path">
      <div :to="menu.path" :class="['flex2 f20', activeIndex === index ? 'active' : '']"
        @click="goItem(menu.path, index)">
        <img class="menuImg" :src="activeIndex === index ? menu.icon_active : menu.icon" />
        <p class="mt-5 f12 text">{{ menu.text }}</p>
      </div>
    </li>
  </ul>
</template>

<script>
import mine from "../assets/icon/mine.png";
import mineActive from "../assets/icon/mine_active.png";
import palletBusiness from "../assets/icon/pallets_business.png";
import palletBusinessActive from "../assets/icon/pallets_business_active.png";

import rea from "../assets/icon/relea.png";
import reaActive from "../assets/icon/relea_active.png";

import dispatchBusiness from "../assets/icon/dispatch_business.png";
import dispatchBusinessActive from "../assets/icon/dispatch_business_active.png";
import dispatchOrder from "../assets/icon/dispatch_order.png";
import dispatchOrderActive from "../assets/icon/dispatch_order_active.png";

import auditOrder from "../assets/audit/workOrder.png";
import auditOrderActive from "../assets/audit/workOrder_active.png";

import peijian from "../assets/audit/peijian.png";
import peijianActive from "../assets/audit/peijian_active.png";

export default {
  name: "hsOrder",
  props: {
    page: Number,
  },
  data() {
    return {
      //"/audit/parts",
      // {
      //   path: "/workOrder/repair",
      //   icon: peijian,
      //   icon_active: peijianActive,
      //   text: "维修",
      // },
      menuLAllist: {
        1: [
          {
            path: "/dispatch/business",
            icon: dispatchBusiness,
            icon_active: dispatchBusinessActive,
            text: "业务计划",
          },
          {
            path: "/dispatch/toExamine",
            icon: dispatchOrder,
            icon_active: dispatchOrderActive,
            text: "审核",
          },
          // {
          //   path: "/dispatch/order",
          //   icon: dispatchOrder,
          //   icon_active: dispatchOrderActive,
          //   text: "工单调度",
          // },
          {
            path: "/my",
            icon: mine,
            icon_active: mineActive,
            text: "我的",
          },
        ],
        2: [
          {
            path: "/accountant/business",
            icon: palletBusiness,
            icon_active: palletBusinessActive,
            text: "业务中标",
          },
          {
            path: "/accountant/release",
            icon: rea,
            icon_active: reaActive,
            text: "发布货源",
          },
          {
            path: "/my",
            icon: mine,
            icon_active: mineActive,
            text: "我的",
          },
        ],
        3: [
          {
            path: "/workOrder/order",
            icon: auditOrder,
            icon_active: auditOrderActive,
            text: "安装",
          },
          {
            path: "/my",
            icon: mine,
            icon_active: mineActive,
            text: "我的",
          },
        ],
        4: [
          {
            path: "/audit/work",
            icon: auditOrder,
            icon_active: auditOrderActive,
            text: "工单",
          },
          // {
          //   path: "/audit/parts",
          //   icon: peijian,
          //   icon_active: peijianActive,
          //   text: "配件",
          // },
          {
            path: "/my",
            icon: mine,
            icon_active: mineActive,
            text: "我的",
          },
        ],
        5: [
          {
            path: "/workOrder/order",
            icon: auditOrder,
            icon_active: auditOrderActive,
            text: "安装",
          },

          {
            path: "/dispatch/order",
            icon: dispatchOrder,
            icon_active: dispatchOrderActive,
            text: "工单调度",
          },
          {
            path: "/my",
            icon: mine,
            icon_active: mineActive,
            text: "我的",
          },
        ],
        6: [
          {
            path: "/generateWorkOrder",
            icon: auditOrder,
            icon_active: auditOrderActive,
            text: "业务列表",
          },

          {
            path: "/my",
            icon: mine,
            icon_active: mineActive,
            text: "我的",
          },
        ],
      },
      currentRole: localStorage.getItem("role"),
    };
  },
  computed: {
    menuList() {
      console.log(this.menuLAllist[this.currentRole], "看啊可能");
      return this.menuLAllist[this.currentRole];
    },
    activeIndex: {
      // return this.page
      get() {
        return this.page;
      },
      set(val) {
        // this.$store.commit('tabChange',{val});
      },
    },
  },
  methods: {
    goItem(path, index) {
      this.activeIndex = index;
      console.log(this.activeIndex, "选中", index, "索引");
      this.$router.push(path);
    },
  },
};
</script>

<style scoped lang="less">
.footer {
  border-top: 1px solid #ebebeb;
  height: 50px;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 3;

  .text {
    color: #797d82;
  }

  .active .text {
    color: #44b1f9;
  }

  .menuImg {
    width: 16px;
    display: block;
    margin: 0 auto;
  }
}
</style>
